import { getToken } from '@/store/local/auth'

export default {
    data() {
        return {
            isLogin: false,
            userInfo: null
        }
    },
    created() {
        this.loginInfo();
    },
    methods: {
        loginInfo() {
            const token = getToken()
            if (!token) {
                this.isLogin = false
                this.userInfo = null
                localStorage.removeItem('userInfo')
            } else {
                const userInfo = localStorage.getItem('userInfo')
                if (userInfo) {
                    try {
                        this.userInfo = JSON.parse(userInfo)
                        this.isLogin = true
                    } catch (e) {
                        this.isLogin = false
                        this.userInfo = null
                        localStorage.removeItem('userInfo')
                    }
                } else {
                    this.isLogin = false
                    this.userInfo = null
                }
            }
        }
    }
}